import DrawHeader from './components/DrawHeader';
import DrawSummary from './DrawSummary';

export const Draw = () => {
  return (
    <div className='container mx-auto'>
      <DrawHeader />
      <div className='mt-5 w-full rounded-md shadow-lg z-10'>
        <DrawSummary />
      </div>
    </div>
  );
};
